import { AnyAction } from "redux";
import { PhoneNumbersState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): PhoneNumbersState => ({
    available: [],
});

const reducer = (state = initialState(), action: AnyAction): PhoneNumbersState => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_FETCH_AVAILABLE_PHONE_NUMBERS):
            return {
                ...state,
                available: action.payload,
            };
        case AT.CHECKOUT_CHOOSE_PHONE_NUMBER_SWITCH_PANEL:
            return {
                ...state,
                selectedPanel: action.activePanel,
            };
        default:
            return state;
    }
};

export default reducer;
